import { Link } from 'react-router-dom'


function NavbarLink({ text, link, children }) {
  return (
    <Link className='navbarLinkContainer' to={link}>
      <span className='NavbarLinkText'>{children}</span>
      <span className='NavbarLinkText'>{text}</span>
    </Link>
  )
}

export default NavbarLink
